import { SummaryCard, Text } from "@pentabd/ui";

import { useLeaveSummary } from "@hooks/HRM/leave/useLeaveSummary";
import { useLanguage } from "@hooks/useLanguage";

import { LeaveType } from "@type/HRM/leave-type";

interface LeaveSummaryProps {
  employeeId: string | number;
}

export const LeaveDetailsSummary = ({ employeeId }: LeaveSummaryProps) => {
  const { language } = useLanguage();
  const { leaveBalance } = useLeaveSummary(employeeId);

  const filteredLeave = leaveBalance?.filter(
    (leaveType: LeaveType) =>
      leaveType?.nameEn?.toUpperCase() === "CASUAL LEAVE" ||
      leaveType?.nameEn?.toUpperCase() === "EARNED LEAVE WITH FULL SALARY" ||
      leaveType?.nameEn?.toUpperCase() === "EARNED LEAVE WITH HALF SALARY",
  );

  return (
    <div className="container pb-10">
      <div className="grid-container gap-8">
        {leaveBalance &&
          filteredLeave?.map(
            ({ nameEn, nameBn, takenLeaveCount, totalLeaveCount }, i) => (
              <div key={i} className="grid-item-summary-card">
                <SummaryCard
                  label={language === "en" ? nameEn : nameBn}
                  body={
                    <div>
                      <Text>{takenLeaveCount ? takenLeaveCount : 0}</Text>
                      <Text
                        sizeType="fs"
                        size="md"
                        weight="normal"
                        className="ms-2"
                      >
                        /{totalLeaveCount ? totalLeaveCount : 0}
                      </Text>
                    </div>
                  }
                  styles={{
                    border: "border",
                    color: "text-dark",
                    background: "bg-white",
                  }}
                />
              </div>
            ),
          )}
      </div>
    </div>
  );
};
